import * as React from "react";
import { Tooltip as MantineTooltip } from "@mantine/core";
import { useTheme } from "styled-components";
const Tooltip = ({ ...props }) => {
  const theme = useTheme();
  const styles = () => ({
    tooltip: {
      backgroundColor: theme.colors.global.contentBackground,
      color: theme.colors.text.primary,
      fontWeight: 400,
      fontSize: theme.fonts.size.root
    }
  });
  return /* @__PURE__ */ React.createElement(MantineTooltip, { zIndex: "var(--mantine-z-index-max)", styles, ...props });
};
export default Tooltip;
